import React, { useRef, useEffect, useState } from 'react'
import platinum from '../../assets/platinum.svg'
import diamond from '../../assets/diamond.svg'
import check from '../../assets/check.svg'
import cross from '../../assets/cross.svg'
import redirect from '../../assets/redirect.svg'
import useLocation from "../../utils/Location";
import { getWhatsappLink } from "../../utils/getWhatsappNumber";

const Monthly = ({ currency }) => {
  const { countryCode } = useLocation();
  const whatsappLink = getWhatsappLink(countryCode);
    const platinumplan = [
        {
            allow: true,
            content: (
                <p >
                    45 Themes Available
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    3 Businesses
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    1000 Appointments
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    1000 Contacts
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    25 Staff Users
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    3 Subdomains
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    3 PWA
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    QR Code
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    10 PVC Cards
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    30 Notifications<span>/month</span> on Dashboard
                </p>
            )
        },
        // {
        //     allow: true,
        //     content: (
        //         <p >
        //             Chat and Email support
        //         </p>
        //     )
        // },
        {
            allow: true,
            content: (
                <p >
                    {/* 500MB Data Storage Limit */}
                    500MB Storage
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    Marketplace Listing
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    5 to 10 Leads every month
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    Dedicated RM Support
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    {/* Advanced Ecommerce Store */}
                    Ecommerce Store
                </p>
            )
        },
        {
            // allow: false,
            allow: true,
            content: (
                <p >
                    Premium UI
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    5 Dedicated Leads
                </p>
            )
        },
        // {
        //     allow: true,
        //     content: (
        //         <p >
        //             WhatsApp integration
        //         </p>
        //     )
        // },
        {
            allow: true,
            content: (
                <p >
                    {/* Google Review Card <span>(Extra charges applicable)</span> */}
                    Google Review Card <span>(Extra cost)</span>
                </p>
            )
        },
        {
            // allow: false,
            allow: true,
            content: (
                <p >
                    Marketing Consultation
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    {/* App & Play Store Submission <span>(Extra charges applicable)</span> */}
                    App Submission (Playstore/Appstore) <span>(3 MONTHS NECESSARY)</span>
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    {/* Metal Card <span>({currency?.currencySymbol}2000 + Plan Price)</span> */}
                    Metal Card {currency?.currencyName === "Dirhams" ? "" : <span>({currency?.currencySymbol}2000 + Plan Price)</span>}
                </p>
            )
        },
    ]
    const diamondplan = [
        {
            allow: true,
            content: (
                <p >
                    45 Themes Available
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    5 Businesses
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    1000 Appointments
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    1000 Contacts
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    50 Staff Users
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    5 Subdomains
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    5 PWA
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    QR Code
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    10 PVC Cards
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    100 Notifications<span>/month</span> on Dashboard
                </p>
            )
        },
        // {
        //     allow: true,
        //     content: (
        //         <p >
        //             Chat and Email support
        //         </p>
        //     )
        // },
        {
            allow: true,
            content: (
                <p >
                    {/* 1024MB Data Storage Limit */}
                    1024MB Storage
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    Marketplace Listing
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    30 to 50 Leads every month
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    Dedicated RM Support
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    {/* Advanced Ecommerce Store */}
                    Ecommerce Store
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    Premium UI
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    20 Dedicated Leads
                </p>
            )
        },
        // {
        //     allow: true,
        //     content: (
        //         <p >
        //             WhatsApp integration
        //         </p>
        //     )
        // },
        {
            allow: true,
            content: (
                <p >
                    {/* Google Review Card <span>(Extra charges applicable)</span> */}
                    Google Review Card <span>(Extra cost)</span>
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    Marketing Consultation
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    {/* App & Play Store Submission <span>(Extra charges applicable)</span> */}
                    App Submission (Playstore/Appstore) <span>(3 MONTHS NECESSARY)</span>
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    Metal Card {currency?.currencyName === "Dirhams" ? "" : <span>({currency?.currencySymbol}2000 + Plan Price)</span>}
                </p>
            )
        },
    ]
    const containerRef = useRef(null)
    const [activeIndex, setActiveIndex] = useState(0)

    useEffect(() => {
        const container = containerRef.current

        const handleScroll = () => {
            const boxes = Array.from(container.children)
            const center = container.scrollLeft + container.offsetWidth / 2

            let closestIndex = 0
            let closestDistance = Infinity

            boxes.forEach((box, i) => {
                const boxCenter = box.offsetLeft + box.offsetWidth / 2
                const distance = Math.abs(center - boxCenter)
                if (distance < closestDistance) {
                    closestDistance = distance
                    closestIndex = i
                }
            })

            setActiveIndex(closestIndex)
        }

        container.addEventListener("scroll", handleScroll, { passive: true })
        return () => container.removeEventListener("scroll", handleScroll)
    }, [])

    const platinumpricing = currency?.currencyName === "Dirhams" ? "AED 500" : `${currency?.currencySymbol}5000.00`;
    const diamondpricing = currency?.currencyName === "Dirhams" ? "AED 1500" : `${currency?.currencySymbol}25000.00`;
    const plans = [
        { name: "Platinum", price: platinumpricing, img: platinum, list: platinumplan },
        { name: "Diamond", price: diamondpricing, img: diamond, list: diamondplan }
    ]
    return (
        <div id='plan' className='plancontainer' ref={containerRef}>
            {plans.map((p, i) => (
                <div key={i} className={`planbox ${activeIndex === i ? "active" : ""}`}>
                    <div className="plannamediv">
                        <div className="planimgbox">
                            <img src={p.img} alt={p.name} />
                        </div>
                        <h3 className="planname">{p.name}</h3>
                    </div>
                    <h4 className='planprice'>
                        {p.price}<span>{currency?.currencyName === "Dirhams" ? "+VAT/monthly" : "/monthly"}</span>
                    </h4>
                    <ul>
                        {p.list.map((item, index) => (
                            <li key={index} className='planlist'>
                                <img src={item.allow ? check : cross} alt="" /> {item.content}
                            </li>
                        ))}
                    </ul>
                    <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className='ctawhatsapp'>
                        <p type="button" className="getstarted">
                            Get Started <span><img src={redirect} alt="redirect" /></span>
                        </p>
                    </a>
                </div>
            ))}
        </div>
    )
}

export default Monthly